import { render, staticRenderFns } from "./MarketplaceProvider.vue?vue&type=template&id=4a52c8dc&scoped=true"
import script from "./MarketplaceProvider.vue?vue&type=script&lang=js"
export * from "./MarketplaceProvider.vue?vue&type=script&lang=js"
import style0 from "./MarketplaceProvider.vue?vue&type=style&index=0&id=4a52c8dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a52c8dc",
  null
  
)

export default component.exports